import type { Store } from '@/types/store';

export const INITIAL_STORES: Store[] = [
  {
    id: 'store_affiches',
    name: 'ArtWall Studio',
    niche: 'Affiches personnalisées',
    color: '#E040FB',
    status: 'active',
    roomId: 's1',
    platform: 'shopify',
    emoji: '🖼',
    description: 'Affiches A3/A2 personnalisées : texte, photo, design minimaliste. Fort taux de cadeaux.',
    launchDate: '2024-03-15',
    assignedAgentIds: ['cipher', 'forge', 'echo'],
    metrics: {
      revenue: 1847,
      sessions: 3420,
      conversionRate: 0.034,
      margin: 0.61,
      orders: 116,
      growth: 12.4,
      avgOrderValue: 15.9,
    },
  },
  {
    id: 'store_animaux',
    name: 'Paw & Love',
    niche: 'Cadeaux animaux personnalisés',
    color: '#00E676',
    status: 'active',
    roomId: 's2',
    platform: 'etsy',
    emoji: '🐾',
    description: 'Mugs, coussins et totebags avec portrait de votre animal. Niche émotionnelle haute valeur.',
    launchDate: '2024-06-01',
    assignedAgentIds: ['nova', 'forge', 'halo'],
    metrics: {
      revenue: 2312,
      sessions: 5800,
      conversionRate: 0.028,
      margin: 0.58,
      orders: 162,
      growth: 23.7,
      avgOrderValue: 14.3,
    },
  },
  {
    id: 'store_citations',
    name: 'Mots qui Restent',
    niche: 'Citations & Déco murale',
    color: '#00E5FF',
    status: 'warning',
    roomId: 's3',
    platform: 'shopify',
    emoji: '✍',
    description: 'Posters typographiques : citations motivantes, humour, famille. Décoration intérieure.',
    launchDate: '2024-09-10',
    assignedAgentIds: ['cipher', 'echo', 'argus'],
    metrics: {
      revenue: 634,
      sessions: 2100,
      conversionRate: 0.018,
      margin: 0.65,
      orders: 38,
      growth: -4.2,
      avgOrderValue: 16.7,
    },
  },
  {
    id: 'store_famille',
    name: 'Premier Chapitre',
    niche: 'Naissance & Famille',
    color: '#FFD700',
    status: 'active',
    roomId: 's4',
    platform: 'etsy',
    emoji: '👶',
    description: 'Cadeaux de naissance premium : affiche personnalisée bébé, tableau famille, faire-part digital.',
    launchDate: '2024-11-20',
    assignedAgentIds: ['nova', 'forge', 'vector'],
    metrics: {
      revenue: 1124,
      sessions: 2890,
      conversionRate: 0.031,
      margin: 0.63,
      orders: 87,
      growth: 34.1,
      avgOrderValue: 12.9,
    },
  },
];
